export enum ErrorsList {
  PRODUCTS_LIMIT_ERROR = "REACHED_PRODUCTS_LIMIT",
}
